// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var App                   = require("./components/App");
var ReactDOMRe            = require("reason-react/lib/js/src/ReactDOMRe.js");
var ReasonReact           = require("reason-react/lib/js/src/ReasonReact.js");
var RegisterServiceWorker = require("./registerServiceWorker");

((require('./index.css')));

ReactDOMRe.renderToElementWithId(ReasonReact.element(/* None */0, /* None */0, App.make(/* array */[])), "root");

RegisterServiceWorker.default();

/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/index.re
// module id = 25
// module chunks = 0